import {PaginationModal} from "./pagination-modal";

export class RequestParamModel {
    pageIndex = 0;
    pageSize = 20;
    totalCount?: number;
    filter?: string = '';
    defaultFilter = "";
    sorts?: string;
    keywords: any;
    pageCount?: any;
    moduleName?: string;

    constructor(filter = null) {
        this.pageIndex = 0;
        this.pageSize = 20;
        if (filter) this.filter = filter
    }

    /**
     * Updates the pagination properties using the provided paginated list object.
     * @param {PaginationModal<T>} pagedList - The pagination data including page size, total count, and current page index.
     */
    update<T>(pagedList: PaginationModal<T>) {
        this.pageSize = pagedList.pageSize;
        this.totalCount = pagedList.totalCount;
        this.pageIndex = pagedList.currentPage;
    }

    /**
     * Adds a default filter to the current filter query string.
     * @param {string} field - The name of the field to apply the filter on.
     * @param {any} value - The value to filter the field by.
     */
    addDefaultFilter(field: string, value: any) {
        if (field && value) {
            this.defaultFilter += "&filter[" + field + "]" + "=" + value;
        }
    }

    /**
     * Updates the filter property by appending a new filter condition.
     * @param {string} field - The name of the field to filter by.
     * @param {any} value - The value to filter the field with.
     */
    setFilter(field: string, value: any) {
        if (field && value) {
            this.filter += "&filter[" + field + "]" + "=" + value;
        }
    }

    /**
     * Removes a specified filter based on the provided field name.
     * @param {string} field - The field name used to identify and remove the filter from the filter string.
     */
    removeFilter(field: string) {
        if (field && this.filter) {
            let filterArray = this.filter.split('&');
            if (filterArray.length > 0) {
                filterArray.forEach(function (value, index) {
                    if (value.includes(field))
                        filterArray.splice(index);
                });

                this.filter = filterArray.join("&");
            }
        }
    }

    /**
     * Removes the default filter for the specified field from the defaultFilter property.
     * @param {string} field - The field name whose filter is to be removed from the current defaultFilter.
     */
    removeDefaultFilter(field: string) {
        if (field && this.defaultFilter) {
            let defaultFilterArray = this.defaultFilter.split('&');
            if (defaultFilterArray.length > 0) {
                defaultFilterArray.forEach(function (value, index) {
                    if (value.includes(field)) {
                        defaultFilterArray.splice(index);
                    }
                });

                this.defaultFilter = defaultFilterArray.join("&");
            }
        }
    }

    /**
     * Builds and returns a query parameter string based on the current instance properties.
     * The method concatenates filters, sorts, pagination, keywords, and module name
     * into a query parameter string suitable for using in URLs. If applicable parameters
     * exist, it ensures the first parameter uses a "?" and additional parameters use "&".
     */
    getParams(): string {
        let param = "";

        if (this.defaultFilter) {
            param += this.defaultFilter;
        }

        if (this.filter) {
            param += this.filter;
        }
        if (this.sorts) {
            param += this.sorts;
        }
        if (this.pageIndex) {
            param += "&page=" + this.pageIndex;
        }
        if (this.pageSize) {
            param += "&pageSize=" + this.pageSize;
        }
        if (this.keywords) {
            param += "&keywords=" + this.keywords;
        }
        if (this.moduleName) {
            param += "&moduleName=" + this.moduleName;
        }
        if (param) {
            param = param.replace("&", "?");
        }
        return param;
    }
}
